import Vue from 'vue';
import Router from "vue-router";
import Body from '../components/body';
import Inicio from '../pages/Inicio';
import Login from '../pages/seguridad/login';

import store from '../store/index';
import decode from 'jwt-decode';

// component
Vue.use(Router);

const routes = [
  { path: '', redirect: { name: 'inicio' } },
  {
    path: '/principal',
    component: Body,
    children: [
      {
        path: 'inicio',
        name: 'inicio',
        component: Inicio,
        meta: {
          title: 'Inicio', requireAuth: true
        }
      },
      {
        path: 'perfil',
        name: 'perfil',
        component: () => import('../pages/Perfil'),
        meta: {
          title: 'Perfil', requireAuth: true
        }
      },
      {
        path: '/extranjero/historialdeclaracion',
        name: 'historialdeclaracion',
        component: () => import('../pages/extranjero/HistorialDeclaracion.vue'),
        meta: { requireAuth: true, extranjeroAuth: true }
      },
      {
        path: '/extranjero/declaracion',
        name: 'declaracion',
        component: () => import('../pages/extranjero/Declaracion.vue'),
        meta: { requireAuth: true, extranjeroAuth: true }
      },
      {
        path: '/analista/frmPersona',
        name: 'frmPersona',
        component: () => import('../pages/analista/frmPersona.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/buscarPersona',
        name: 'buscarPersona',
        component: () => import('../pages/analista/buscarPersona.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/analisisSeguimiento',
        name: 'analisisSeguimiento',
        component: () => import('../pages/analista/analisisSeguimiento.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/BuscarExtranjeroSicof',
        name: 'BuscarExtranjeroSicof',
        component: () => import('../pages/analista/BuscarExtranjeroSicof.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/ReportePorOperador',
        name: 'ReportePorOperador',
        component: () => import('../pages/analista/ReportePorOperador.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/ReporteDiario',
        name: 'ReporteDiario',
        component: () => import('../pages/analista/ReporteDiario.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/sancionOperadorFrontera',
        name: 'sancionOperadorFrontera',
        component: () => import('../pages/analista/sancionOperadorFrontera.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/Revisar',
        name: 'revisar',
        component: () => import('../pages/analista/Revisar.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/RevisarSancion',
        name: 'revisarSancion',
        component: () => import('../pages/analista/RevisarSancion.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/RevisarSancionDistrital',
        name: 'RevisarSancionDistrital',
        component: () => import('../pages/analista/RevisarSancionDistrital.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/DetalleDeclaracion',
        name: 'DetalleDeclaracion',
        component: () => import('../pages/analista/DetalleDeclaracion.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/buscarEmpresas',
        name: 'buscarEmpresas',
        component: () => import('../pages/analista/BuscarEmpresas.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/mapeo',
        name: 'mapeo',
        component: () => import('../pages/analista/Mapeo.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/analista/BuscarExtranjero',
        name: 'buscarExtranjero',
        component: () => import('../pages/analista/BuscarExtranjero.vue'),
        meta: { requireAuth: true, analistaAuth: true }
      },
      {
        path: '/empresa/Empresas',
        name: 'empresas',
        component: () => import('../pages/empresa/Empresas.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/Partes',
        name: 'partes',
        component: () => import('../pages/empresa/Partes.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/PartesTerrestres',
        name: 'partesTerrestres',
        component: () => import('../pages/empresa/PartesTerrestres.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/PartesAgencia',
        name: 'partesAgencia',
        component: () => import('../pages/empresa/PartesAgencia.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/PartesInstituciones',
        name: 'partesInstituciones',
        component: () => import('../pages/empresa/PartesInstituciones.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/PartesNocturnas',
        name: 'partesNocturnas',
        component: () => import('../pages/empresa/PartesNocturnas.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/centroHospedaje',
        name: 'centroHospedaje',
        component: () => import('../pages/empresa/CentroHospedaje.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/reporteEmpresa',
        name: 'reporteEmpresa',
        component: () => import('../pages/empresa/reporteEmpresa.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/ReportePorEmpresa',
        name: 'ReportePorEmpresa',
        component: () => import('../pages/empresa/ReportePorEmpresa.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/PartesHospedaje',
        name: 'partesHospedaje',
        component: () => import('../pages/empresa/PartesHospedaje.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/NuevoEmpresa',
        name: 'NuevoEmpresa',
        component: () => import('../pages/empresa/NuevoEmpresa.vue'),
        meta: { requireAuth:true, empresaAuth: true }
      },
      {
        path: '/empresa/EditarEmpresa/:id',
        name: 'EditarEmpresa',
        component: () => import('../pages/empresa/EditarEmpresa.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/PartesAereo',
        name: 'partesAereo',
        component: () => import('../pages/empresa/PartesAereo.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/empresa/Reportes',
        name: 'reportes',
        component: () => import('../pages/empresa/Reportes.vue'),
        meta: { requireAuth: true, empresaAuth: true }
      },
      {
        path: '/automatizado/Equipos',
        name: 'Equipos',
        component: () => import('../pages/automatizado/Equipos'),
        meta: {
          requireAuth: true, automatizacionAuth: true
        }
      },
      {
        path: '/automatizado/Vuelos',
        name: 'Vuelos',
        component: () => import('../pages/automatizado/Vuelos'),
        meta: {
          requireAuth: true, automatizacionAuth: true
        }
      },
      {
        path: '/automatizado/listaRobot',
        name: 'listaRobot',
        component: () => import('../pages/automatizado/listaRobot'),
        meta: {
          requireAuth: true, automatizacionAuth: true
        }
      },
      {
        path: '/automatizado/ReporteVuelos',
        name: 'ReporteVuelos',
        component: () => import('../pages/automatizado/ReporteVuelos'),
        meta: {
          requireAuth: true, automatizacionAuth: true
        }
      },
      {
        path: '/robot/FormularioError',
        name: 'FormularioRobot',
        component: () => import('../pages/robot/FormularioError'),
        meta: {
          requireAuth: true, automatizacionAuth: true
        }
      },
      {
        path: '/robot/reporteRobot',
        name: 'reporteRobot',
        component: () => import('../pages/robot/reporteRobot'),
        meta: {
          requireAuth: true, automatizacionAuth: true
        }
      },
      {
        path: '/robot/reporteRobotED2',
        name: 'reporteRobot',
        component: () => import('../pages/robot/reporteRobotED2'),
        meta: {
          requireAuth: true, automatizacionAuth: true
        }
      },
      {
        path: '/robot/crearReporte',
        name: 'crearReporte',
        component: () => import('../pages/robot/crearReporte'),
        meta: {
          requireAuth: true, automatizacionAuth: true
        }
      },
      {
        path: '/robot/reportesError',
        name: 'reporteError',
        component: () => import('../pages/robot/reportesError'),
        meta: {
          requireAuth: true, automatizacionAuth: true
        }
      },
      {
        path: '/reporte/reporteEmpresa',
        name: 'reporteEmpresaFecha',
        component: () => import('../pages/reporte/ReporteEmpresa.vue'),
        meta: { requireAuth: true, reporteAuth: true }
      },
      {
        path: '/reporte/reporteAereo',
        name: 'reporteAereo',
        component: () => import('../pages/reporte/ReporteAereo.vue'),
        meta: { requireAuth: true, reporteAuth: true }
      },
      {
        path: '/reporte/reporteHotel',
        name: 'reporteHotel',
        component: () => import('../pages/reporte/ReporteHotel.vue'),
        meta: { requireAuth: true, reporteAuth: true }
      },
      {
        path: '/ventanilla/analisisSeguimientoVentanilla',
        name: 'analisisSeguimientoVentanilla',
        component: () => import('../pages/ventanilla/analisisSeguimientoVentanilla.vue'),
        meta: { requireAuth: true, ventanillaAuth: true }
      },
    ]
  },
  {
    path: '/seguridad/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Login',
    }
  },
  {
    path: '/extranjero/empadronarextranjero/:id',
    name: 'empadronarExtranjero',
    component: () => import('../pages/extranjero/EmpadronarExtranjero'),
    meta: {
      title: 'Login',
    }
  },
  {
    path: '/empresa/RegistrarmeEmpadronamiento',
    name: 'RegistrarmeEmpadronamiento',
    component: () => import('../pages/empresa/RegistrarmeEmpadronamiento'),
    meta: {
      title: 'Login',
    }
  }


];

const router = new Router({
  routes,
  base: `${process.env.VUE_APP_BASE_URL}`,
  mode: 'hash',
  linkActiveClass: "active",
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {

  const rutaProtegida = to.matched.some(record => record.meta.requireAuth);
  const rutaAnalista = to.matched.some(record => record.meta.operadorAuth);
  const rutaEmpresa = to.matched.some(record => record.meta.empresaAuth);
  const rutaAutomatizacion = to.matched.some(record => record.meta.automatizacionAuth);
  const rutaVentanilla = to.matched.some(record => record.meta.ventanillaAuth);

  if (rutaProtegida && store.state.token === '') {
    next({ name: 'login' });
  } else if (rutaAnalista) {
    const user = decode(localStorage.getItem('token'));
    let id_rol = Number(user.id_rol);

    if (id_rol === 2) {
      next();
    } else {
      next({ name: 'inicio' });
    }

  }
  else if (rutaEmpresa) {
    const user = decode(localStorage.getItem('token'));
    let id_rol = Number(user.id_rol);

    if (id_rol === 3) {
      next();
    } else {
      next({ name: 'inicio' });
    }
  }
  else if (rutaAutomatizacion) {
    const user = decode(localStorage.getItem('token'));
    let id_rol = Number(user.id_rol);

    if (id_rol === 6 || id_rol === 10) {
      next();
    } else {
      next({ name: 'inicio' });
    }
  }
  else if (rutaVentanilla) {
    const user = decode(localStorage.getItem('token'));
    let id_rol = Number(user.id_rol);

    if (id_rol === 8) {
      next();
    } else {
      next({ name: 'inicio' });
    }
  }
  else {

    next();
  }

});

export default router;
